(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HomeController', Controller);

    /* @ngInject */
    function Controller() {
        var vm = this;

    }

})(angular);
